// External Dependencies:
import React from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import 'es6-promise/auto'
import axios from 'axios'
import ReactPixel from 'react-facebook-pixel'
ReactPixel.init( siteData.facebook_pixel_id, {}, {} )

// Internal Dependencies:
import MediaPlayer from 'components/MediaPlayer/MediaPlayer'
import { getUrlParameter } from 'utilities/url'

const host = window.location.host

class PageEvents extends React.Component {
	componentDidMount() {
		this.doUpdate()
	}

	componentWillUnmount() {
		window.removeEventListener( 'click', this.handleLinkClick )
		window.removeEventListener( 'submit', this.handleFormSubmit )
		window.removeEventListener( 'click', this.handleAccordionTitleClick )
	}

	componentDidUpdate( prevProps, prevState ) {
		this.doUpdate()
	}

	doUpdate() {
		const { page } = this.props

		// Links:
		const elements = document.querySelectorAll( '.content-body-wrap a, .content-custom-wrap a' )

		Array.from( elements ).forEach( ( element ) => {
			element.addEventListener( 'click', this.handleLinkClick )
		})

		// Forms:
		const forms = document.querySelectorAll( '.content-body-wrap form, .content-custom-wrap form' )

		Array.from( forms ).forEach( ( form ) => {
			form.addEventListener( 'submit', this.handleFormSubmit )
		})

		if ( page && 'contact' == page.template && forms[0] ) {
			let textareaValue = ''
			let type = getUrlParameter( 'type' )

			if ( 'sketch' == type ) {
				textareaValue = `Hi!\n\nI like to sketch, and I want to get involved in the Animation Coop.\n\nTell me more!`
			} else if ( 'sound' == type ) {
				textareaValue = `Hi!\n\nI like producing all kinds of sounds, and I want to get involved in the Animation Coop.\n\nTell me more!`
			} else if ( 'technical' == type ) {
				textareaValue = `Hi!\n\nI'm good with computers, and I want to get involved in the Animation Coop.\n\nTell me more!`
			} else if ( 'voice' == type ) {
				textareaValue = `Hi!\n\nI'm good at doing voices, and I want to get involved in the Animation Coop.\n\nTell me more!`
			} else if ( 'general' == type ) {
				textareaValue = `Hi!\n\nI want to get involved in the Animation Coop.\n\nTell me more!`
			} else if ( 'music' == type ) {
				textareaValue = `Hi!\n\nI like to create music, and I want to get involved in the Animation Coop.\n\nTell me more!`
			} else if ( 'animator' == type ) {
				textareaValue = `Hi!\n\nI like doing animation, and I want to get involved in the Animation Coop.\n\nTell me more!`
			}

			forms[0].querySelector( 'textarea' ).value = textareaValue
		}

		// Recaptchas:
		const recaptchas = document.querySelectorAll( '.page-section .frm-g-recaptcha, .content-custom-wrap .frm-g-recaptcha' )

		Array.from( recaptchas ).forEach( ( recaptcha ) => {
			if ( 'undefined' != typeof grecaptcha ) {
				let recaptchaID = grecaptcha.render( recaptcha, {
					'sitekey': recaptcha.getAttribute( 'data-sitekey' )
				} )
				recaptcha.setAttribute( 'data-rid', recaptchaID )
				recaptcha.classList.remove( 'frm-g-recaptcha' )
			}
		})

		// Accordions:
		const accordionContents = document.querySelectorAll( '.accordion-content' )

		Array.from( accordionContents ).forEach( ( element ) => {
			let section = element.parentNode

			element.style.maxHeight = '900000px'
			section.setAttribute( 'data-height', element.scrollHeight + 100 )

			if ( section.classList.contains( 'is-target' ) ) {
				section.classList.remove( 'is-not-active' )
				section.classList.add( 'is-active' )
				element.style.maxHeight = `${element.scrollHeight}px`
			} else {
				element.style.maxHeight = '0'
			}
		})

		const accordionTitles = document.querySelectorAll( '.accordion-title' )

		Array.from( accordionTitles ).forEach( ( accordionTitle ) => {
			accordionTitle.addEventListener( 'click', this.handleAccordionTitleClick )
		})

		// Videos:
		this.updateVideos()
	}

	updateVideos = () => {
		const videos = document.querySelectorAll( '.video-data' )

		Array.from( videos ).forEach( ( element ) => {
			let id = element.getAttribute( 'data-video-id' )
			let service = element.getAttribute( 'data-type' )
			let url = element.getAttribute( 'data-url' )

			ReactDOM.render(
				<MediaPlayer id={ id } service={ service } url={ url } />,
				element
			)
		})
	}

	handleLinkClick = ( e ) => {
		const { history } = this.props
		let href = e.currentTarget.getAttribute( 'href' )
		href = href.replace( /^(\.+)/g, '' )

		if ( href.indexOf( host ) > -1 && href.indexOf( '//' ) > -1 ) {
			window.location( href ) // Same network, different site, open normally.
		} else if ( href.indexOf( '//' ) > -1 ) {
			window.open( href, '_blank' ) // External site, in new tab.
		} else if ( '#' == href.charAt( 0 ) ) {
			let hash = href.substring( 1 )
			window.location.hash = hash
		} else {
			history.push( href ) // Same site, use router.
		}

		e.preventDefault()
	}

	handleFormSubmit = ( e ) => {
		const form = e.currentTarget
		const buttons = form.querySelectorAll( 'button' )
		const formData = new FormData( form )
		formData.append( 'action', 'theme_formidable_submit_form' )

		e.preventDefault()

		// disable the button
		if ( buttons.length ) {
			buttons[0].setAttribute( 'disabled', 'disabled' )
		}

		form.classList.remove( 'is-successful' )
		form.classList.add( 'is-processing' )

		// submit
		axios.post( siteData.ajax_url, formData )
		.then( response => {
			// success

			ReactPixel.track( 'Contact' )

			form.classList.remove( 'has-error' )
			form.setAttribute( 'data-message', '' )

			form.classList.remove( 'is-processing' )
			form.classList.add( 'is-processed' )

			// add a delay for UX
			setTimeout( () => {
				form.classList.remove( 'is-processed' )
				form.classList.add( 'is-successful' )

				// set the success message
				form.setAttribute( 'data-message', response.data )

				setTimeout( () => {
					form.classList.remove( 'is-successful' )

					// enable the button
					if ( buttons.length ) {
						buttons[0].removeAttribute( 'disabled', 'disabled' )
					}

					// clear form
					form.reset()
				}, 1000 )
			}, 1000 )
		})
		.catch( error => {
			// error

			form.classList.remove( 'is-processing' )
			form.classList.add( 'is-processed' )

			// add a delay for UX
			setTimeout( () => {
				form.classList.remove( 'is-processed' )
				form.classList.add( 'is-unsuccessful' )

				// set the error text
				form.classList.add( 'has-error' )
				error.response && form.setAttribute( 'data-message', error.response.data )

				setTimeout( () => {
					form.classList.remove( 'is-unsuccessful' )

					// enable the button
					if ( buttons.length ) {
						buttons[0].removeAttribute( 'disabled', 'disabled' )
					}
				}, 3000 )
			}, 1000 )
		})
	}

	handleAccordionTitleClick = ( e ) => {
		e.preventDefault()

		const section = e.currentTarget.parentNode
		const content = section.querySelector( '.accordion-content' )
		const height = section.getAttribute( 'data-height' )

		if ( ! content ) {
			return
		}

		if ( ! section.classList.contains( 'is-active' ) && ! section.classList.contains( 'is-target' ) ) {
			section.classList.remove( 'is-not-active' )
			section.classList.add( 'is-active' )
			content.style.maxHeight = `${height}px`
		} else {
			section.classList.remove( 'is-active' )
			section.classList.add( 'is-not-active' )
			content.style.maxHeight = '0'
		}
	}

	render() {
		return null
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

export default withRouter(
	connect( mapStateToProps )( PageEvents )
)



// WEBPACK FOOTER //
// ./containers/PageEvents.jsx